import {
  hydratedUser,
  logout,
  signInWithCredentials,
  signInWithSessionToken
} from '@/features/login/slice';

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: null,
  id: null,
  type: null,
  session_token: null,
  super_admin: null,
  venue_ids: [],
  organization_id: null,
  ...hydratedUser
};

const loggedOutState = {
  email: null,
  id: null,
  type: null,
  session_token: null,
  super_admin: null,
  venue_ids: [],
  organization_id: null
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.email = action.payload.email;
      state.id = action.payload.id;
      state.type = action.payload.type;
      state.session_token = action.payload.session_token;
      state.super_admin = action.payload.super_admin;
      state.venue_ids = action.payload.venue_ids;
      state.organization_id = action.payload.organization_id;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(signInWithCredentials.fulfilled, (state, action) => {
        state.email = action.payload.email;
        state.id = action.payload.id;
        state.type = action.payload.type;
        state.session_token = action.payload.session_token;
        state.super_admin = action.payload.super_admin;
        state.venue_ids = action.payload.venue_ids;
        state.organization_id = action.payload.organization_id;
      })
      .addCase(signInWithSessionToken.fulfilled, (state, action) => {
        state.email = action.payload.email;
        state.id = action.payload.id;
        state.type = action.payload.type;
        state.session_token = action.payload.session_token;
        state.super_admin = action.payload.super_admin;
        state.venue_ids = action.payload.venue_ids;
        state.organization_id = action.payload.organization_id;
      })
      .addCase(logout.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(logout.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.error || 'Failed to log out';
      })
      .addCase(logout.fulfilled, (state) => {
        Object.assign(state, loggedOutState); // Properly reset state
        state.user = {};
      });
  }
});

export const { setUser } = userSlice.actions;
export default userSlice.reducer;
